import { render, staticRenderFns } from "./ListReview_organization.vue?vue&type=template&id=07c321a7&scoped=true"
import script from "./ListReview_organization.vue?vue&type=script&lang=js"
export * from "./ListReview_organization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c321a7",
  null
  
)

export default component.exports